import { type ReactNode } from 'react';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AssignmentIndTwoToneIcon from '@mui/icons-material/AssignmentIndTwoTone';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import ReviewsIcon from '@mui/icons-material/Reviews';
import SmartToyTwoToneIcon from '@mui/icons-material/SmartToyTwoTone';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TocIcon from '@mui/icons-material/Toc';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { accessControl } from 'src/utils/accessControl';
import { AccessControlTypeEnum } from 'src/utils/enum';

const permissionRole = accessControl(AccessControlTypeEnum.RMA);
const permissionUser = accessControl(AccessControlTypeEnum.UMA);
const permissionVendor = accessControl(AccessControlTypeEnum.VLMA);
const permissionDashboard = accessControl(AccessControlTypeEnum.DA);
const permissionPackage = accessControl(AccessControlTypeEnum.SLMA);
const permissionMaster = accessControl(AccessControlTypeEnum.MDA);
const permissionBannerTop = accessControl(AccessControlTypeEnum.BTA);
const permissionBannerBottom = accessControl(AccessControlTypeEnum.BBA);
const permissionLeadVendor = accessControl(AccessControlTypeEnum.VWLA);
const permissionLeadCustomer = accessControl(AccessControlTypeEnum.CLA);
const permissionReview = accessControl(AccessControlTypeEnum.RARA);
const permissionContent = accessControl(AccessControlTypeEnum.CMA);

export interface MenuItem {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  badgeTooltip?: string;
  items?: MenuItem[];
  name: string;
}

export interface MenuItems {
  items: MenuItem[];
  heading: string;
}

const adminMenuItems: MenuItems[] = [
  (permissionDashboard?.isAdd ||
    permissionDashboard?.isDelete ||
    permissionDashboard?.isExport ||
    permissionDashboard?.isImport ||
    permissionDashboard?.isUpdate ||
    permissionDashboard?.isView) && {
    heading: 'General',
    items: [
      {
        name: 'Dashboard',
        icon: SmartToyTwoToneIcon,
        link: '/admin/dashboard/home'
      },
      {
        name: 'Referral Management',
        icon: CardGiftcardIcon,
        link: '/admin/dashboard/referrals'
      },
      {
        name: 'System Config',
        icon: SettingsIcon,
        link: '/admin/dashboard/system-config'
      },
      {
        name: 'SOS Alerts',
        icon: NotificationsActiveIcon,
        link: '/admin/dashboard/sos-alerts'
      }
    ]
  },
  permissionRole &&
  permissionUser &&
  permissionVendor &&
  (permissionRole?.isAdd ||
    permissionRole?.isDelete ||
    permissionRole?.isExport ||
    permissionRole?.isImport ||
    permissionRole?.isUpdate ||
    permissionRole?.isView) &&
  (permissionUser?.isAdd ||
    permissionUser?.isDelete ||
    permissionUser?.isExport ||
    permissionUser?.isImport ||
    permissionUser?.isUpdate ||
    permissionUser?.isView) &&
  (permissionVendor?.isAdd ||
    permissionVendor?.isDelete ||
    permissionVendor?.isExport ||
    permissionVendor?.isImport ||
    permissionVendor?.isUpdate ||
    permissionVendor?.isView)
    ? {
        heading: 'Management',
        items: [
          {
            name: 'User & Role Management',
            icon: AssignmentIndTwoToneIcon,
            link: '/admin/dashboard/management/user-management',
            items: [
              {
                name: 'Roles',
                link: 'management/user-management/roles'
              },
              {
                name: 'Users',
                link: 'management/user-management/users'
              }
            ]
          },

          {
            name: 'Vendor Management',
            icon: AssignmentIndTwoToneIcon,
            link: '/admin/dashboard/management/vendor-management',
            items: [
              {
                name: 'Vendors',
                link: 'management/vendor-management/vendors'
              }
            ]
          }
        ]
      }
    : permissionUser &&
      (permissionUser?.isAdd ||
        permissionUser?.isDelete ||
        permissionUser?.isExport ||
        permissionUser?.isImport ||
        permissionUser?.isUpdate ||
        permissionUser?.isView) &&
      permissionRole &&
      (permissionRole?.isAdd ||
        permissionRole?.isDelete ||
        permissionRole?.isExport ||
        permissionRole?.isImport ||
        permissionRole?.isUpdate ||
        permissionRole?.isView)
    ? {
        heading: 'Management',
        items: [
          {
            name: 'User & Role Management',
            icon: AssignmentIndTwoToneIcon,
            link: '/vendor/dashboard/management/user-management',
            items: [
              {
                name: 'Users',
                link: 'management/user-management/users'
              },
              {
                name: 'Roles',
                link: 'management/user-management/roles'
              }
            ]
          }
        ]
      }
    : permissionUser &&
      permissionVendor &&
      (permissionUser?.isAdd ||
        permissionUser?.isDelete ||
        permissionUser?.isExport ||
        permissionUser?.isImport ||
        permissionUser?.isUpdate ||
        permissionUser?.isView) &&
      (permissionVendor?.isAdd ||
        permissionVendor?.isDelete ||
        permissionVendor?.isExport ||
        permissionVendor?.isImport ||
        permissionVendor?.isUpdate ||
        permissionVendor?.isView)
    ? {
        heading: 'Management',
        items: [
          {
            name: 'User & Role Management',
            icon: AssignmentIndTwoToneIcon,
            link: '/admin/dashboard/management/user-management',
            items: [
              {
                name: 'Users',
                link: 'management/user-management/users'
              }
            ]
          },

          {
            name: 'Vendor Management',
            icon: AssignmentIndTwoToneIcon,
            link: '/admin/dashboard/management/vendor-management',
            items: [
              {
                name: 'Vendors',
                link: 'management/vendor-management/vendors'
              }
            ]
          }
        ]
      }
    : permissionRole &&
      permissionVendor &&
      (permissionRole?.isAdd ||
        permissionRole?.isDelete ||
        permissionRole?.isExport ||
        permissionRole?.isImport ||
        permissionRole?.isUpdate ||
        permissionRole?.isView) &&
      (permissionVendor?.isAdd ||
        permissionVendor?.isDelete ||
        permissionVendor?.isExport ||
        permissionVendor?.isImport ||
        permissionVendor?.isUpdate ||
        permissionVendor?.isView)
    ? {
        heading: 'Management',
        items: [
          {
            name: 'User & Role Management',
            icon: AssignmentIndTwoToneIcon,
            link: '/admin/dashboard/management/user-management',
            items: [
              {
                name: 'Roles',
                link: 'management/user-management/roles'
              }
            ]
          },

          {
            name: 'Vendor Management',
            icon: AssignmentIndTwoToneIcon,
            link: '/admin/dashboard/management/vendor-management',
            items: [
              {
                name: 'Vendors',
                link: 'management/vendor-management/vendors'
              }
            ]
          }
        ]
      }
    : permissionRole &&
      (permissionRole?.isAdd ||
        permissionRole?.isDelete ||
        permissionRole?.isExport ||
        permissionRole?.isImport ||
        permissionRole?.isUpdate ||
        permissionRole?.isView)
    ? {
        heading: 'Management',
        items: [
          {
            name: 'User & Role Management',
            icon: AssignmentIndTwoToneIcon,
            link: '/vendor/dashboard/management/user-management',
            items: [
              {
                name: 'Roles',
                link: 'management/user-management/roles'
              }
            ]
          }
        ]
      }
    : permissionUser &&
      (permissionUser?.isAdd ||
        permissionUser?.isDelete ||
        permissionUser?.isExport ||
        permissionUser?.isImport ||
        permissionUser?.isUpdate ||
        permissionUser?.isView)
    ? {
        heading: 'Management',
        items: [
          {
            name: 'User & Role Management',
            icon: AssignmentIndTwoToneIcon,
            link: '/vendor/dashboard/management/user-management',
            items: [
              {
                name: 'Users',
                link: 'management/user-management/users'
              }
            ]
          }
        ]
      }
    : permissionVendor &&
      (permissionVendor?.isAdd ||
        permissionVendor?.isDelete ||
        permissionVendor?.isExport ||
        permissionVendor?.isImport ||
        permissionVendor?.isUpdate ||
        permissionVendor?.isView)
    ? {
        heading: 'Management',
        items: [
          {
            name: 'Vendor Management',
            icon: AssignmentIndTwoToneIcon,
            link: '/admin/dashboard/management/vendor-management',
            items: [
              {
                name: 'Vendors',
                link: 'management/vendor-management/vendors'
              }
            ]
          }
        ]
      }
    : undefined,

  permissionPackage?.isAdd ||
  permissionPackage?.isDelete ||
  permissionPackage?.isExport ||
  permissionPackage?.isImport ||
  permissionPackage?.isUpdate ||
  permissionPackage?.isView
    ? {
        heading: 'Package',
        items: [
          {
            name: 'Service Management',
            icon: Inventory2Icon,
            link: '/admin/dashboard/package/view-package',
            items: [
              {
                name: 'Packages',
                link: 'package/view-package/hajj-umrah-package'
              }
            ]
          }
        ]
      }
    : undefined,
  permissionMaster?.isAdd ||
  permissionMaster?.isDelete ||
  permissionMaster?.isExport ||
  permissionMaster?.isImport ||
  permissionMaster?.isUpdate ||
  permissionMaster?.isView
    ? {
        heading: 'Master',
        items: [
          {
            name: 'Master Data',
            icon: FolderSpecialIcon,
            link: '/admin/dashboard/master/master-data'
          },
          {
            name: 'Location Master',
            icon: FolderSpecialIcon,
            link: '/admin/dashboard/master/location-master'
          }
        ]
      }
    : undefined,
  (permissionBannerTop?.isAdd ||
    permissionBannerTop?.isDelete ||
    permissionBannerTop?.isExport ||
    permissionBannerTop?.isImport ||
    permissionBannerTop?.isUpdate ||
    permissionBannerTop?.isView) &&
  (permissionBannerBottom?.isAdd ||
    permissionBannerBottom?.isDelete ||
    permissionBannerBottom?.isExport ||
    permissionBannerBottom?.isImport ||
    permissionBannerBottom?.isUpdate ||
    permissionBannerBottom?.isView)
    ? {
        heading: 'Banner',
        items: [
          {
            name: 'Banner Management',
            icon: ViewCarouselIcon,
            link: '/admin/dashboard/banner/banner-data',
            items: [
              {
                name: 'Banner Top',
                link: 'banner/banner-data/banner-top'
              },
              {
                name: 'Banner Bottom',
                link: 'banner/banner-data/banner-bottom'
              }
            ]
          }
        ]
      }
    : permissionBannerTop?.isAdd ||
      permissionBannerTop?.isDelete ||
      permissionBannerTop?.isExport ||
      permissionBannerTop?.isImport ||
      permissionBannerTop?.isUpdate ||
      permissionBannerTop?.isView
    ? {
        heading: 'Banner',
        items: [
          {
            name: 'Banner Management',
            icon: ViewCarouselIcon,
            link: '/admin/dashboard/banner/banner-data',
            items: [
              {
                name: 'Banner Top',
                link: 'banner/banner-data/banner-top'
              }
            ]
          }
        ]
      }
    : permissionBannerBottom?.isAdd ||
      permissionBannerBottom?.isDelete ||
      permissionBannerBottom?.isExport ||
      permissionBannerBottom?.isImport ||
      permissionBannerBottom?.isUpdate ||
      permissionBannerBottom?.isView
    ? {
        heading: 'Banner',
        items: [
          {
            name: 'Banner Management',
            icon: ViewCarouselIcon,
            link: '/admin/dashboard/banner/banner-data',
            items: [
              {
                name: 'Banner Bottom',
                link: 'banner/banner-data/banner-bottom'
              }
            ]
          }
        ]
      }
    : undefined,

  (permissionLeadCustomer?.isAdd ||
    permissionLeadCustomer?.isDelete ||
    permissionLeadCustomer?.isExport ||
    permissionLeadCustomer?.isImport ||
    permissionLeadCustomer?.isUpdate ||
    permissionLeadCustomer?.isView) &&
  (permissionLeadVendor?.isAdd ||
    permissionLeadVendor?.isDelete ||
    permissionLeadVendor?.isExport ||
    permissionLeadVendor?.isImport ||
    permissionLeadVendor?.isUpdate ||
    permissionLeadVendor?.isView)
    ? {
        heading: 'Lead',
        items: [
          {
            name: 'Lead Management',
            icon: SupportAgentIcon,
            link: '/admin/dashboard/lead-management/view-lead',
            items: [
              {
                name: 'Customer Lead',
                link: 'lead-management/view-lead/customer-lead'
              },
              {
                name: 'Vendor Lead',
                link: 'lead-management/view-lead/vendor-lead'
              }
            ]
          }
        ]
      }
    : permissionLeadCustomer?.isAdd ||
      permissionLeadCustomer?.isDelete ||
      permissionLeadCustomer?.isExport ||
      permissionLeadCustomer?.isImport ||
      permissionLeadCustomer?.isUpdate ||
      permissionLeadCustomer?.isView
    ? {
        heading: 'Lead',
        items: [
          {
            name: 'Lead Management',
            icon: SupportAgentIcon,
            link: '/admin/dashboard/lead-management/view-lead',
            items: [
              {
                name: 'Customer Lead',
                link: 'lead-management/view-lead/customer-lead'
              }
            ]
          }
        ]
      }
    : permissionLeadVendor?.isAdd ||
      permissionLeadVendor?.isDelete ||
      permissionLeadVendor?.isExport ||
      permissionLeadVendor?.isImport ||
      permissionLeadVendor?.isUpdate ||
      permissionLeadVendor?.isView
    ? {
        heading: 'Lead',
        items: [
          {
            name: 'Lead Management',
            icon: SupportAgentIcon,
            link: '/admin/dashboard/lead-management/view-lead',
            items: [
              {
                name: 'Vendor Lead',
                link: 'lead-management/view-lead/vendor-lead'
              }
            ]
          }
        ]
      }
    : undefined,

  permissionReview?.isAdd ||
  permissionReview?.isDelete ||
  permissionReview?.isExport ||
  permissionReview?.isImport ||
  permissionReview?.isUpdate ||
  permissionReview?.isView
    ? {
        heading: 'Review and Rating',
        items: [
          {
            name: 'Review And Rating Management',
            icon: ReviewsIcon,
            link: '/admin/dashboard/review-rating-management/review-and-rating'
          }
        ]
      }
    : undefined,
  permissionContent?.isAdd ||
  permissionContent?.isDelete ||
  permissionContent?.isExport ||
  permissionContent?.isImport ||
  permissionContent?.isUpdate ||
  permissionContent?.isView
    ? {
        heading: 'Content',
        items: [
          {
            name: 'Content Management',
            icon: TocIcon,
            link: '/admin/dashboard/content-management/content'
          }
        ]
      }
    : undefined
];

const vendorMenuItems: MenuItems[] = [
  {
    heading: 'General',
    items: [
      {
        name: 'Dashboard',
        icon: SmartToyTwoToneIcon,
        link: '/vendor/dashboard/home'
      },
      {
        name: 'Business Profile',
        icon: AccountCircleIcon,
        link: '/vendor/dashboard/business-profile'
      },
      {
        name: 'Referral Management',
        icon: CardGiftcardIcon,
        link: '/vendor/dashboard/referrals'
      },
      {
        name: 'SOS Alerts',
        icon: NotificationsActiveIcon,
        link: '/vendor/dashboard/sos-alerts'
      }
    ]
  },
  {
    heading: 'Package',
    items: [
      {
        name: 'Service Management',
        icon: Inventory2Icon,
        link: '/vendor/dashboard/package/view-package',
        items: [
          {
            name: 'Packages',
            link: 'package/view-package/hajj-umrah-package'
          }
        ]
      }
    ]
  },
  {
    heading: 'Lead',
    items: [
      {
        name: 'Lead Management',
        icon: StickyNote2Icon,
        link: '/admin/dashboard/lead-management/view-lead',
        items: [
          {
            name: 'Customer Lead',
            link: 'lead-management/view-lead/customer-lead'
          }
        ]
      }
    ]
  }
  // {
  //   heading: 'Management',
  //   items: [
  //     {
  //       name: 'User & Role Management',
  //       icon: AssignmentIndTwoToneIcon,
  //       link: '/vendor/dashboard/management/user-management',
  //       items: [
  //         {
  //           name: 'Roles',
  //           link: 'management/user-management/roles'
  //         },
  //         {
  //           name: 'Users',
  //           link: 'management/user-management/users'
  //         }
  //       ]
  //     }
  //   ]
  // },
];

const forexVendorMenuItems: MenuItems[] = [
  {
    heading: 'General',
    items: [
      {
        name: 'Dashboard',
        icon: SmartToyTwoToneIcon,
        link: '/vendor/dashboard/home'
      },
      {
        name: 'Business Profile',
        icon: AccountCircleIcon,
        link: '/vendor/dashboard/business-profile'
      }
    ]
  },

  {
    heading: 'Lead',
    items: [
      {
        name: 'Lead Management',
        icon: StickyNote2Icon,
        link: '/admin/dashboard/lead-management/view-lead',
        items: [
          {
            name: 'Customer Lead',
            link: 'lead-management/view-lead/customer-lead'
          }
        ]
      }
    ]
  }
  // {
  //   heading: 'Management',
  //   items: [
  //     {
  //       name: 'User & Role Management',
  //       icon: AssignmentIndTwoToneIcon,
  //       link: '/vendor/dashboard/management/user-management',
  //       items: [
  //         {
  //           name: 'Roles',
  //           link: 'management/user-management/roles'
  //         },
  //         {
  //           name: 'Users',
  //           link: 'management/user-management/users'
  //         }
  //       ]
  //     }
  //   ]
  // },
];

export { adminMenuItems, forexVendorMenuItems, vendorMenuItems };
